import _ from "lodash";
import { formatDate } from "utils/helpers";


export const filteredData = (
    opStatusFilterValues,
    opDateFilterValues,
    nameFilterValues,
    lastNameFilterValues,
    documentFilterValues,
    batchFilterValues,
    typesFilterValues
) => {

    const filterKeys = {
        opStatus: opStatusFilterValues,
        opDate: opDateFilterValues,
        name: nameFilterValues,
        lastName:lastNameFilterValues,
        documents: documentFilterValues,
        batch: batchFilterValues,
        type:typesFilterValues && typesFilterValues.toString()
    };


    const filters = {
        opStatus: () => `id_ob_operation_status in [${opStatusFilterValues.join(';')}],`,
        opDate: () => `created_at be [${formatDate(opDateFilterValues)}],`,
        name:()=>`person_name li *${nameFilterValues}*,`,
        lastName:()=>`person_lastname li *${lastNameFilterValues}*,`,
        documents:() => `person_tributary_key li *${documentFilterValues}*,`,
        batch:()=>`batch_number eq ${batchFilterValues},`,
        type:()=>`id_type eq ${typesFilterValues},`
    };
    const appliedFilters = [];
    _.forOwn(filterKeys, (val, key) => {
        if (!_.isEmpty(val)) {
            appliedFilters.push((appliedFilters[key] = filters[key]));
        }
    });

    let filterQuery = ''
    appliedFilters && appliedFilters.forEach(filter => {
        filterQuery = filterQuery + filter()
    })
    const query = { filters: filterQuery}
    return query;
}